export const rubros = [
    {
        id: 1,
        "nombre": "01.-Normatividad",
        "icono": "Normatividad.png",
        "url": "0",
        "formatos": [
            {
                "nombre": "Marco Normativo",
                "xlsx": "a69_f01 SADERH.xlsx",
                "html": "a69_f01 SADERH.htm"
            },
        ]
    }, 
    {
        id: 2,
        "nombre": "02.-Estructura",
        "icono":"Estructura.png",
        "url": "0",
        "formatos": [
            {
                "nombre": "Estructura Orgánica",
                "xlsx": "a69_f02_a SADERH.xlsx",
                "html": "a69_f02_a SADERH.htm"
            },
            {
                "nombre": "Organigrama",
                "xlsx": "a69_f02_b SADERH.xlsx",
                "html": "a69_f02_b SADERH.htm"
            }
        ]
    },
    {
        id: 3,
        "nombre": "03.-Facultades",
        "icono":"Facultades.png",
        "url": "0",
        "formatos": [
            {
                "nombre": "Facultades",
                "xlsx": "a69_f03 SADERH.xlsx",
                "html": "a69_f03 SADERH.htm"
            }
        ]
    },
    {
        id: 4,
        "nombre": "04.-Programas Operativos Anuales",
        "icono":"ProgramasOperativosAnuales.png",
        "url": "0",
        "formatos": [
            {
                "nombre": "Metas y Objetivos",
                "xlsx": "a69_f04 SADERH.xlsx",
                "html": "a69_f04 SADERH.htm"
            }
        ]
        
    },
    {
        id: 5,
        "nombre": "05.-Indicadores de Interés",
        "icono":"IndicadoresInteres.png",
        "url": "0",
        "formatos": [
            {
                "nombre": "Indicadores de Interés",
                "xlsx": "a69_f5 SADERH.xlsx",
                "html": "a69_f5 SADERH.htm"
            }
        ]
        
    },
    {
        id: 6,
        "nombre": "06.-Matriz de Indicadores",
        "icono":"MatrizIndicadores.png",
        "url": "0",
        "formatos": [
            {
                "nombre": "Matriz de Indicadores",
                "xlsx": "a69_f6 SADERH.xlsx",
                "html": "a69_f6 SADERH.htm"
            }
        ]
        
    },
    {
         id: 7,
        "nombre": "07.-Directorio",
        "icono":"Directorio.png",
        "url": "0",
        "formatos": [
            {
                "nombre": "Directorio",
                "xlsx": "a69_f07 SADERH.xlsx",
                "html": "a69_f07 SADERH.htm"
            }
        ]
        
    },
    {
         id: 8,
        "nombre": "08.-Sueldos",
        "icono":"Sueldos.png",
        "url": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/8.%20Sueldos",
        "formatos": [
           
        ]
        
    },
    {
         id: 9,
        "nombre": "09.-Viáticos",
        "icono":"Viaticos.png",
        "url": "0",
        "formatos": [
            {
                "nombre": "Viáticos",
                "xlsx": "a69_f9 SADERH.xlsx",
                "html": "a69_f9 SADERH.htm"
            }
        ]	
    },
    {
        id: 10,
        "nombre": "10.-Plazas",
        "icono":"Plazas.png",
        "url": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/10.%20Plazas",
        "formatos": [
    
        ]	
    },
    {
        id: 11,
        "nombre": "11.-Honorarios",
        "icono":"Honorarios.png",
        "url": "0",
        "formatos": [
            {
                "nombre": "Personal de Honorarios",
                "xlsx": "a69_f11 SADERH.xlsx",
                "html": "a69_f11 SADERH.htm"
            }
        ]	
    },
    {
        id: 12,
        "nombre": "12.-Declaraciones Públicas",
        "icono":"DeclaracionesPublicas.png",
        "url": "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/12.%20Declaraciones%20P%C3%Bablicas",
        "formatos": [
            
        ]	
    },
    {
        id: 13,
        "nombre": "13.-Datos de Contacto de la Unidad",
        "icono":"DatosContactoUnidad.png",
        "url": "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/13.%20Datos%20de%20Contacto%20de%20la%20Unidad",
        "formatos": [
           
        ]
    },
    {
        id: 14,
        "nombre": "14.-Convocatorias",
        "icono":"Convocatorias.png",
        "url": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/14.%20Convocatorias",
        "formatos": [
        ]
    },
    {
        id: 15,
        "nombre": "15.-Programas Sociales",
        "icono":"ProgramasSociales.png",
        "url": "0",
        "formatos": [
            {
                "nombre": "Programas de Subsidio, Estimulo y Apoyo",
                "xlsx": "a69_f15_a SADERH.xlsx",
                "html": "a69_f15_a SADERH.htm"
            },
            {
                "nombre": "Padrón de beneficiarios",
                "xlsx": "a69_f15_b SADERH.xlsx",
                "html": "a69_f15_b SADERH.htm"
            }
        ]
    },
    {
        id: 16,
        "nombre": "16.-Relaciones Laborales",
        "icono":"RelacionesLaborales.png",
        "url": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/16.%20Relaciones%20Laborales",
        "formatos": [
            
        ]
    },
    {
        id: 17,
        "nombre": "17.-Información Curricular",
        "icono":"InformacionCurricular.png",
        "url": "0",
        "formatos": [
            {
                "nombre": "Información Curricular",
                "xlsx": "a69_f17 SADERH.xlsx",
                "html": "a69_f17 SADERH.htm"
            }
        ]
    },
    {
        id: 18,
        "nombre": "18.-Sanciones Administrativas",
        "icono":"SancionesAdministrativas.png",
        "url": "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/18.%20Sanciones%20Administrativas",
        "formatos": [
            
        ]	
    },
    {
        id: 19,
        "nombre": "19.-Servicios",
        "icono":"Servicios.png",
        "url": "0",
        "formatos": [
            {
                "nombre": "Servicios",
                "xlsx": "a69_f19 SADERH.xlsx",
                "html": "a69_f19 SADERH.htm"
            }
        ]
        
    },
    {
        id: 20,
        "nombre": "20.-Trámites",
        "icono":"Tramites.png",
        "url": "0",
        "formatos": [
            {
                "nombre": "Trámites",
                "xlsx": "a69_f20 SADERH.xlsx",
                "html": "a69_f20 SADERH.htm"
            }
        ]
        
    },
    {
        id: 21,
        "nombre": "21.-Presupuesto e Informes Trimestrales",
        "icono":"PresupuestoInformesTrimestrales.png",
        "url": "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/21.Presupuesto%20e%20Informes%20Trimestrales",
        "formatos": [
           
        ]
        
    },
    {
        id: 22,
        "nombre": "22.-Deuda Pública",
        "icono":"DeudaPublica.png",
        "url": "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/22.Deuda%20P%C3%BAblica",
        "formatos": [
            
        ]
    },
    {
        id: 23,
        "nombre": "23.-Comunicación Social y Publicidad",
        "icono":"ComunicacionSocialPublicidad.png",
        "url": "0",
        "formatos": [
            {
                "nombre": "Programa Anual de Comunicación Social",
                "xlsx": "a69_f23_a SADERH.xlsx",
                "html": "a69_f23_a SADERH.htm"
            },
            {
                "nombre": "Erogación de Recursos de Comunicación Social",
                "xlsx": "a69_f23_b SADERH.xlsx",
                "html": "a69_f23_b SADERH.htm"
            },
            {
                "nombre": "Tiempos Oficiales",
                "xlsx": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/RadioTVH/dir1/FC/a69_f23_c_RTH.xlsx",
                "html": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/RadioTVH/dir1/FC/a69_f23_c_RTH.htm"
            },
            

        ]
    },
    {
        id: 24,
        "nombre": "24.-Resultados de Auditorías",
        "icono":"ResultadosAuditorias.png",
        "url": "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/24.%20Resultados%20de%20Auditor%C3%ADas",
        "formatos": [
            
        ]
    },
    {
        id: 25,
        "nombre": "25.-Dictámines de Estados Financiero",
        "icono":"DictamenesFinancieros.png",
        "url": "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/25.Dict%C3%A1menes%20de%20Estados%20Financieros",
        "formatos": [
            
        ]
        
    },
    {
        id: 26,
        "nombre": "26.-Asignación de Recursos Públicos a Personas",
        "icono":"AsignacionRecursosPublicosPersonas.png",
        "url": "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/26.Asignacion%20de%20Recursos%20Publicos%20a%20Personas",
        "formatos": [
           
        ]
        
    },
    {
        id: 27,
        "nombre": "27.-Concesiones",
        "icono":"Concesiones.png",
        "url": "0",
        "formatos": [
            {
                "nombre": "Concesiones, Contratos, Convenios, Permisos, Licencias y Autorizaciones",
                "xlsx": "a69_f27 SADERH.xlsx",
                "html": "a69_f27 SADERH.htm"
            }
        ]
        
    },
    {
        id: 28,
        "nombre": "28.-Licitaciones Públicas",
        "icono":"LicitacionesPublicas.png",
        "url": "0",
        "formatos": [
            {
                "nombre": "Procedimientos de Adjudicación Directa, Licitación Pública e Invitación Restringida",
                "xlsx": "2026_a69_f28_SADERH.xlsx",
                "html": "2026_a69_f28_SADERH.htm",
            
            },
            
        ]
        
    },
    {
        id: 29,
        "nombre": "29.-Informes",
        "icono":"Informes.png",
        "url": "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/29.%20Informes",
        "formatos": [
            
        ]
        
    },
    {
        id: 30,
        "nombre": "30.-Estadísticas Generadas",
        "icono":"EstadisticasGenerales.png",
        "url": "0",
        "formatos": [
            {
                "nombre": "Estadísticas",
                "xlsx": "a69_f30 SADERH.xlsx",
                "html": "a69_f30 SADERH.htm"
            }
        ]
        
    },
    {
        id: 31,
        "nombre": "31.-Informe de Avances y Documentos Financiero",
        "icono":"InformeAvancesDocumentosFinancieros.png",
        "url": "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/31.Informe%20de%20Avances%20y%20Documentos%20Financieros",
        "formatos": [
            
        ]
        
    },
    {
        id: 32,
        "nombre": "32.-Padrón de Proveedores y Contratistas",
        "icono":"PadronProveedoresContratistas.png",
        "url": "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/32.%20Padr%C3%B3n%20de%20Proveedores%20y%20Contratistas",
        "formatos": [
           
        ]
        
    },
    {
        id: 33,
        "nombre": "33.-Convenios con Sectores Social y Privado",
        "icono":"ConveniosSectoresSocialPrivado.png",
        "url": "0",
        "formatos": [
            {
                "nombre": "Convenios de Coordinación y Concertación",
                "xlsx": "a69_f33 SADERH.xlsx",
                "html": "a69_f33 SADERH.htm"
            }
        ]
        
    },
    {
        id: 34,
        "nombre": "34.-Inventario de Bienes",
        "icono":"InventarioBienes.png",
        "url": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/34.%20Inventario%20de%20Bienes",
        "formatos": [
         
        ]
        
    },
    {
        id: 35,
        "nombre": "35.-Recomendaciones y Atención en Materia de Derechos Humanos",
        "icono":"RecomendacionesAtenciónMateriaDerechosHumanos.png",
        "url": "0",
        "formatos": [
            {
                "nombre": "Recomendaciones de Derechos Humanos Emitidas por la CNDH",
                "xlsx": "a69_f35_a SADERH.xlsx",
                "html": "a69_f35_a SADERH.htm"
            },
            {
                "nombre": "Recomendaciones de Derechos Humanos Casos Especiales",
                "xlsx": "a69_f35_b SADERH.xlsx",
                "html": "a69_f35_b SADERH.htm"
            },
            {
                "nombre": "Las Recomendaciones de Derechos Humanos Org. Int. CNDH",
                "xlsx": "a69_f35_c SADERH.xlsx",
                "html": "a69_f35_c SADERH.htm"
            },
        ]
        
    },
    {
        id: 36,
        "nombre": "36.-Resoluciones y Laudos de Juicios",
        "icono":"ResolucionesLaudosJuicios.png",
        "url": "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/36.%20Resoluciones%20y%20Laudos%20de%20Juicios",
        "formatos": [
            
        ]
        
    },
    {
        id: 37,
        "nombre": "37.-Mecanismo de Participación Ciudadana",
        "icono":"MecanismosParticipacionCiudadana.png",
        "url": "0",
        "formatos": [
            {
                "nombre": "Mecanismos de Participación Ciudadana",
                "xlsx": "a69_f37_a SADERH.xlsx",
                "html": "a69_f37_a SADERH.htm"
            },
            {
                "nombre": "Resultados de los Mecanismos de Participación Ciudadana",
                "xlsx": "a69_f37_b SADERH.xlsx",
                "html": "a69_f37_b SADERH.htm"
            }
        ]
        
    },
    {
        id: 38,
        "nombre": "38.-Programas Ofrecidos",
        "icono":"ProgramasOfrecidos.png",
        "url": "0",
        "formatos": [
            {
                "nombre": "Programas que Ofrecen",
                "xlsx": "a69_f38_a SADERH.xlsx",
                "html": "a69_f38_a SADERH.htm"
            },
            {
                "nombre": "Tramites a los Programas que Ofrecen",
                "xlsx": "a69_f38_b SADERH.xlsx",
                "html": "a69_f38_b SADERH.htm"
            }
        ]
        
    },
    {
        id: 39,
        "nombre": "39.-Actas y Resoluciones del Comité de Transparencia",
        "icono":"ActasResolucionesComiteTransparencia.png",
        "url": "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/39.%20Actas%20y%20Resoluciones%20del%20Comit%C3%A9%20de%20Transparencia",
        "formatos": [
            
        ]
        
    },
    {
        id: 40,
        "nombre": "40.-Evaluacion y Encuesta a Programas Financiados con Recursos Públicos",
        "icono":"EvaluacionencuestasProgramas.png",
        "url": "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/40.Evaluacion%20y%20Encuestas%20a%20Programas%20Financiados%20con%20Recursos%20P%C3%BAblicos",
        "formatos": [
            
           
        ]	
        
    },
    {
        id: 41,
        "nombre": "41.-Estudios Pagados con Recursos Públcos",
        "icono":"EstudiosPagadosRecursosPublicos.png",
        "url": "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/41.Estudios%20Pagados%20con%20Recursos%20P%C3%BAblicos",
        "formatos": [
            
        ]
        
    },
    {
        id: 42,
        "nombre": "42.-Listados Jubilados y Pensionados",
        "icono":"ListadoJubiladosPencionados.png",
        "url": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/42.%20Listados%20Jubilados%20y%20Pensionados",
        "formatos": [
           
        
        ]	
        
    },
    {
        id: 43,
        "nombre": "43.-Ingresos Recibidos por Cualquier Concepto",
        "icono":"IngresosRecibidosCualquierConcepto.png",
        "url": "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/43.Ingresos%20Recibidos%20por%20Cualquier%20Concepto",
        "formatos": [
          
        ]	
        
    },
    {
        id: 44,
        "nombre": "44.-Donaciones Hechas a Terceros",
        "icono":"DonacionesHechasTerceros.png",
        "url": "0",
        "formatos": [
            {
                "nombre": "Donaciones en dinero y especie realizadas",
                "xlsx": "2026_a69_f44 SADERH.xlsx",
                "html": "2026_a69_f44 SADERH.htm"
            },
        
        ]	
        
    },
    {
        id: 45,
        "nombre": "45.-Catálogo Documental y Guia de Archivos",
        "icono":"Viaticos.png",
        "url": "0",
        "formatos": [
            {
                "nombre": "Inventarios documentales",
                "xlsx": "2026_a69_f45_a SADERH.xlsx",
                "html": "2026_a69_f45_a SADERH.htm"
            },
            {
                "nombre": "Índice de expedientes clasificados",
                "xlsx": "https://s-contraloria.hidalgo.gob.mx/Transparencia/xlsx/a69_f45b_SC.xlsx",
                "html": "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f45b_SC.htm"
            },
            {
                "nombre": "Cuardo General de Clasificción Archivística, Catálogo de disposición documntal, Guía de archivo, Informe Anual de Desarrollo Archivístico,Informe Anual de Cumplimiento, Actas y dictámenes de baja doumental.",
                "xlsx": "2024_a69_f45_c SADERH.xlsx",
                "html": "2024_a69_f45_c SADERH.htm"
            }
        ]
    },
    {
        id: 46,
        "nombre": "46.-Actas de Sesiones, Opiniones y Recomendaciones de Consejos Consultivos",
        "icono":"CatalogoDocumentalGuiaArchivos.png",
        "url": "0",
        "formatos": [
            {
                "nombre": "Actas del Consejo Consultivo Ciudadano",
                "xlsx": "a69_f46a SADERH.xlsx",
                "html": "a69_f46a SADERH.htm"
            },
            {
                "nombre": "Opiniones del Consejo Consultivo Ciudadano",
                "xlsx": "a69_f46b SADERH.xlsx",
                "html": "a69_f46b SADERH.htm"
            }
        ]	
        
    },
    {
        id: 47,
        "nombre": "47.-Solicitud de Intervecion de  Comunicaciones",
        "icono":"SolicitudIntervencionComunicaciones.png",
        "url": "https://procuraduria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/Solicitud%20de%20Intervenci%C3%B3n%20de%20%20Comunicaciones",
        "formatos": [
              
        ]
        
    },
    {
        id: 48,
        "nombre": "48.-Información de Utilidad o Relevante",
        "icono":"InformacionUtilidadRelevante.png",
        "url": "0",
        "formatos": [
            {
                "nombre": "Interés Público",
                "xlsx": "a69_f48_a SADERH.xlsx",
                "html": "a69_f48_a SADERH.htm"
            },
            {
                "nombre": "Preguntas Frecuentes",
                "xlsx": "a69_f48_b SADERH.xlsx",
                "html": "a69_f48_b SADERH.htm"
            },
            {
                "nombre": "Transparencia Proactiva",
                "xlsx": "a69_f48_c SADERH.xlsx",
                "html": "a69_f48_c SADERH.htm"
            }
        ]

        
    },
]